import { AbilityBuilder, PureAbility, type AbilityClass } from '@casl/ability'
import { Advent24Users, Users } from './known-users'
import { Advent24Submission } from '~/models/submission'

export type Actions = 'manage' | 'create' | 'read' | 'update' | 'delete'
export type Subjects = Advent24Submission | typeof Advent24Submission | 'all'

export type AppAbility = PureAbility<[Actions, Subjects]>
export const AppAbility = PureAbility as AbilityClass<AppAbility>

export function defineRulesFor (user: string) {
  const { can, rules } = new AbilityBuilder(AppAbility)

  if (user === Users.nicholai) {
    can('manage', 'all')
  }

  if (Advent24Users.includes(user)) {
    can(['create', 'read', 'update', 'delete'], Advent24Submission, { user })
  }

  return rules
}

export function buildAbilityFor (user: string) {
  return new AppAbility(defineRulesFor(user))
}
